import { getEnv } from "@/utils/env"

export const QUERY_VIEW_TYPE = "spaceViewType"

export const SESSION_KEY_SKIP_ARN_WARNING = "skipArnWarning"

export const LINK_ARN_GUIDE = getEnv("VUE_APP_ARN_DOCUMENTATION")
